import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';
// oxlint-disable-next-line typescript/ban-ts-comment
// @ts-ignore - process.env types are cursed
const pillarEnableHttpsEnv = process.env.__PILLAR_ENABLE_HTTPS === 'true';
export default function getPillarEnableHttps(): boolean | undefined {
	return (
		// oxlint-disable-next-line typescript/consistent-type-assertions
		(globalThis as GlobalThisWithLocalDevContext).localDevContext?.__PILLAR_ENABLE_HTTPS ??
		pillarEnableHttpsEnv
	);
}
